import React, { useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate, useSearchParams, Navigate } from 'react-router-dom';

import { useConfig } from 'config/ConfigContext';

import Merchant from './pages/MerchantApply';
import MedicalTourism from './pages/MedicalTourism';
import Congrats from './pages/Congrats';
import Decline from './pages/Decline';

import withIPAddress from './withIPAddress';
import './App.scss';

const routes = [
  {
    name: 'Merchant',
    pathname: '/',
    component: withIPAddress(Merchant),
    exact: true,
  },
  {
    name: 'Congratulations',
    pathname: '/congrats',
    component: Congrats,
  },
  {
    name: 'Declined',
    pathname: '/declined',
    component: Decline,
  },
  {
    name: 'Medical Tourism',
    pathname: '/medical-tourism',
    component: withIPAddress(MedicalTourism),
  },
];

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const config = useConfig();

  const addNoIndexMetaTag = () => {
    if (document.querySelector('meta[name="robots"]')) {
      return;
    }

    const metaTag = document.createElement('meta');
    metaTag.name = 'robots';
    metaTag.content = 'noindex, nofollow';
    document.head.appendChild(metaTag);
  };

  useEffect(() => {
    if (config.env !== 'production') {
      addNoIndexMetaTag();
    }
  }, []);

  return (
    <Routes>
      {routes.map((route, index) => (
        <Route
          key={index}
          path={route.pathname}
          element={(
            <route.component
              location={location}
              navigate={navigate}
              searchParams={searchParams}
            />
          )}
          {...(route.exact && { exact: route.exact })}
        />
      ))}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
